import React from "react";
import Packages from "../../Components/Packages/Packages";
import Packages2 from "../../Components/Packages2/Packages2";
import PageHeading from "../../Components/PageHeading/PageHeading";
import "./Pricing.css";
import MetaData from "../../Components/MetaData/MetaData";
import APIPackage from "../../Components/APIPackage/APIPackage";
import Charge from "../ApiSettings/Charge";

const Pricing = () => {
  return (
    <div>
      <MetaData
        pageTitle={
          "Best Generative AI Tool for Beginners | Easy Generative AI"
        }
        pageDescription={
          "Find the best generative AI tools for beginners to create text, images, audio, and more. Enjoy user-friendly platforms designed for easy learning and creativity."
        }
        canonical="https://whalesai.com/pricing"
      ></MetaData>
      <PageHeading title="Pricing" />

      <section className="pb-4 pb-md-5">
        <div className="container px-4 mx-auto">
          <Packages />
        </div>
      </section>

      <section className="py-4 py-md-5">
        <div className="container px-4 mx-auto">
          {/* <APIPackage /> */}
          <Charge />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "10px 0 0",
            }}
          >
            <p className="text-white text-center"><span className="text-danger">*</span>Based on Credits Package 3.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
